import { useParams } from 'react-router';
import NavrhAktuEu from '../../../model/NavrhAktuEu';
import { ClientStatus } from '../../../model/ClientStatus';
import { useClientFetch } from '../../../context/ClientStatusContext';
import { fetchNavrhAktuEuDetail } from '../../../client/external/aktEuDetailClient';
import Uuid from '../../../model/Uuid';

interface ReturnType {
  aktEuDetail?: NavrhAktuEu | null;
  aktEuStatus: ClientStatus;
}

export default (): ReturnType => {
  const { uuid } = useParams<{ uuid: string }>();
  const {
    data: aktEuDetail,
    status: aktEuStatus,
  } = useClientFetch(
    () => fetchNavrhAktuEuDetail(<Uuid>uuid),
    [uuid],
  );
  return {
    aktEuDetail,
    aktEuStatus,
  };
};
